export default __webpack_public_path__ + "static/media/Six.28cae42c.svg";